import { collection, doc, getDoc, getDocs, setDoc, updateDoc } from 'firebase/firestore';
import { Timestamp } from 'firebase/firestore';
import { db } from './client';
import { mapProfileDoc } from './mappers';
import type { Profile } from '@/lib/types';

export interface ProfileRepository {
  getProfile: (userId: string) => Promise<Profile | null>;
  setProfile: (userId: string, data: { display_name: string; role: string; email?: string | null }) => Promise<void>;
  listProfiles: () => Promise<Profile[]>;
  updateRole: (userId: string, role: string) => Promise<void>;
}

const profilesCollection = collection(db, 'profiles');

export const profileRepository: ProfileRepository = {
  async getProfile(userId) {
    const profileDoc = await getDoc(doc(db, 'profiles', userId));
    if (!profileDoc.exists()) return null;
    return mapProfileDoc(profileDoc.id, profileDoc.data() as Record<string, unknown>);
  },

  async setProfile(userId, data) {
    await setDoc(doc(db, 'profiles', userId), {
      display_name: data.display_name,
      role: data.role,
      email: data.email ?? null,
      created_at: Timestamp.now(),
    });
  },

  async listProfiles() {
    const snap = await getDocs(profilesCollection);
    return snap.docs.map((d) => mapProfileDoc(d.id, d.data() as Record<string, unknown>));
  },

  async updateRole(userId, role) {
    await updateDoc(doc(db, 'profiles', userId), { role });
  },
};
